var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',[_c('NavigationBar')],1),_c('div',{staticClass:"elc0"},[_c('el-aside',{staticStyle:{"width":"250px","position":"fixed"}},[_c('SideBar')],1),_c('el-main',{staticStyle:{"padding-left":"250px"}},[_c('RouterView',{staticClass:"rtv"})],1)],1),_c('newLogin',{ref:"newlogin"}),_c('Device')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }